import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';

export function OptionSkeleton() {
  return (
    <Stack
      aria-label="options-skeleton"
      spacing="36px"
    >
      <Stack spacing="20px">
        <Skeleton
          height={30}
          width="80%"
        />
        <Stack spacing={{ xs: '16px', md: '8px' }}>
          {Array.from({ length: 3 }, (_, key) => (
            <Skeleton
              height={114}
              key={key}
              width="100%"
            />
          ))}
        </Stack>
      </Stack>
      <Stack spacing="20px">
        <Skeleton
          height={30}
          width="80%"
        />
        <Stack spacing={{ xs: '16px', md: '8px' }}>
          <Skeleton
            height={114}
            width="100%"
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
